import { PROYECT } from "services/api";
import { reportResumeDayTypes } from "redux/reducers/Reports/reportResumeDay/types";
import { saveAs } from 'file-saver';
import axios from "axios";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";
const { SET_REPORT_RESUME_DAY_FILTERS } = reportResumeDayTypes


export const getReportResumeDayAction = ({ date, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const token = getState().login.token || localStorage.getItem('crm-user');
    const auth = { headers: { authorization: token } };
    const reportUrl = `${process.env.REACT_APP_URL}${PROYECT}/day-report/resume/pdf?idStation=${station.id}&date=${date}&pdf=${isPdf}`;
    const fileName = `Reporte_Resumen_Día_${station.name}_${date}.${isPdf ? `pdf` : 'xlsx'}`;

    dispatch(startRequestComp('loadingReportResumeDay'))
    const access = {
      url: reportUrl,
      method: 'GET',
      responseType: 'blob',
      ...auth
    }
    try {
      const pdf = await axios(access)
      saveAs(pdf.data, fileName)
      dispatch(setSnackbar(`${isPdf ? `PDF` : `Excel`} Descargado con éxito`, "success"))
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)))
    } finally {
      dispatch(stopRequestComp('loadingReportResumeDay'))
    }
  }
}

export const setReportResumeDayFilters = (key = "", value) => {
  return {
    type: SET_REPORT_RESUME_DAY_FILTERS,
    payload: { value, key }
  }
}
